// extracted by mini-css-extract-plugin
export default {"arrow":"CollapsibleContainer_arrow__02WNA","open":"CollapsibleContainer_open__qO6qF","closed":"CollapsibleContainer_closed__lzBc0","header":"CollapsibleContainer_header__3zLKu"};